import { createContext, useContext } from 'react'
import { ManageEventDetailDayjs } from './event-edit/EventEditPage'

export type ManageEventContextType = {
  event: ManageEventDetailDayjs
  updateEvent: ({
    payload,
    notifyInvitees,
    notifyRSVPdInvitees,
    emailIdentityId,
    publish
  }: {
    payload: Partial<ManageEventDetailDayjs>
    notifyInvitees?: boolean
    notifyRSVPdInvitees?: boolean
    emailIdentityId?: number | null
    publish?: boolean
  }) => void
  updateRecurringEventSeries: ({
    payload,
    notifyInvitees,
    notifyRSVPdInvitees,
    emailIdentityId,
    publish
  }: {
    payload: Partial<ManageEventDetailDayjs>
    notifyInvitees?: boolean
    notifyRSVPdInvitees?: boolean
    emailIdentityId?: number | null
    publish?: boolean
  }) => void
  isRecurringSeries: boolean
  isRecurringInstance: boolean
}

export const ManageEventContext = createContext<ManageEventContextType>(
  null as any
)

export const useManageEventContext = () => useContext(ManageEventContext)
